import classNames from 'classnames';

import styles from '../../../styles/icons/base.module.scss';

interface CircleCheckProps {
    color?: string;
    className?: string;
}

function CircleCheck({ color = 'currentColor', className = null }: CircleCheckProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="45.435"
            height="45.435"
            viewBox="0 0 45.435 45.435"
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <path
                d="M26.092,3.375A22.717,22.717,0,1,0,48.81,26.092,22.784,22.784,0,0,0,26.092,3.375ZM21.429,38.2,9.786,26.562,13.052,23.3l8.388,8.388,17.7-17.7,3.266,3.266Z"
                transform="translate(-3.375 -3.375)"
                fill={color}
            />
        </svg>
    );
}

export default CircleCheck;
